import { DEPENDENCIAS } from '../actions/types';

const initialState = {
    listado: [],
    detalles: null, 
    listado_usuarios: [],
    detalles_usuario: null,
    ventana_filtros: false, 
    filtros: null
};

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch ( type ) {
        case DEPENDENCIAS.BUSCAR:
            return {
                ...state,
                listado: payload
            };

        case DEPENDENCIAS.DETALLES:
            return {
                ...state,
                detalles: payload
            };

        case DEPENDENCIAS.EDITAR:
            return {
                detalles: {
                    ...state.detalles,
                    informacion_personal: {
                        ...state.detalles.informacion_personal,
                        status: payload.status
                    }
                },
                listado: state.listado.map(
                    empresa => empresa._id === payload._id 
                        ? 
                            {
                                ...empresa,
                                status: payload.status
                            } 
                        : 
                            empresa
                )
            };

        case DEPENDENCIAS.ELIMINAR:
            return {
                ...state,
                listado: state.listado.filter( empresa => empresa._id !== payload.id )
            };

        case DEPENDENCIAS.FILTROS:
            return {
                ...state,
                ventana_filtros: payload
            };

        case DEPENDENCIAS.USUARIOS.BUSCAR:
            return {
                ...state,
                listado_usuarios: payload
            };

        case DEPENDENCIAS.USUARIOS.AGREGAR:
            return {
                ...state,
                listado_usuarios: [
                    ...state.listado_usuarios, payload
                ]
            };

        case DEPENDENCIAS.USUARIOS.DETALLES:
            return {
                ...state,
                detalles_usuario: payload
            };

        case DEPENDENCIAS.USUARIOS.EDITAR:
            return {
                ...state,
                listado_usuarios: state.listado_usuarios.map(usuario => usuario._id === payload._id ? payload : usuario)
            };

        case DEPENDENCIAS.USUARIOS.ELIMINAR:
            return {
                ...state,
                listado_usuarios: state.listado_usuarios.filter( usuario => usuario._id !== payload.id )
            };

        default:
            return state;
    }
}